"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const paramsFormatter_1 = (0, tslib_1.__importDefault)(require("../paramsFormatter"));
const resultFormatter_1 = (0, tslib_1.__importDefault)(require("../resultFormatter"));
exports.default = {
    localNodeInfo: {
        method: 'local_node_info',
        paramsFormatters: [],
        resultFormatters: resultFormatter_1.default.toLocalNodeInfo,
    },
    getPeers: {
        method: 'get_peers',
        paramsFormatters: [],
        resultFormatters: resultFormatter_1.default.toPeers,
    },
    getBannedAddresses: {
        method: 'get_banned_addresses',
        paramsFormatters: [],
        resultFormatters: resultFormatter_1.default.toBannedAddresses,
    },
    clearBannedAddresses: {
        method: 'clear_banned_addresses',
        paramsFormatters: [],
    },
    setBan: {
        method: 'set_ban',
        paramsFormatters: [],
    },
    syncState: {
        method: 'sync_state',
        paramsFormatters: [],
        resultFormatters: resultFormatter_1.default.toSyncState,
    },
    setNetworkActive: {
        method: 'set_network_active',
        paramsFormatters: [paramsFormatter_1.default.toBoolean],
    },
    addNode: {
        method: 'add_node',
        paramsFormatters: [],
    },
    removeNode: {
        method: 'remove_node',
        paramsFormatters: [],
    },
    pingPeers: {
        method: 'ping_peers',
        paramsFormatters: [],
    },
};
//# sourceMappingURL=net.js.map